import {ComponentEnum} from "@/config/config-types"
import {lookupURL} from "@/config/app-settings";

export type FungusRecordFieldValue = (string | ComponentEnum | boolean | number | Date | null | [] | [number, number] | [string, string] | FungusRecordField[] | FungusRecordField[][])

export interface FungusRecordField {
    name: string,
    type: string,
    title: string,
    component: ComponentEnum,
    required: boolean,
    multiple: boolean,
    help: string,
    value: FungusRecordFieldValue,
    defaultValue: FungusRecordFieldValue,
    unit?: string,
    placeholder?: FungusRecordFieldValue,
    min?: number, // numbers only
    max?: number, // numbers only
    api?: string, // categories only

}

export interface FungusRecordFieldCategory extends FungusRecordField {
    api: string,

}

export const newSuggestedTaxon = function () {
    return [

        {
            name: "suggestedTaxonName",
            type: "string",
            title: "help.suggestedTaxonNameTitle",
            component: ComponentEnum.StringPicker,
            multiple: false,
            required: false,
            placeholder: 'help.suggestedTaxonNamePlaceholder',
            value: null,
            help: "help.suggestedTaxonName",
            defaultValue: null,
        }, {
            name: "suggestedTaxonPublication",
            type: "string",
            title: "help.suggestedTaxonPublicationTitle",
            component: ComponentEnum.StringPicker,
            multiple: false,
            required: true,
            placeholder: 'help.suggestedTaxonPublicationPlaceholder',
            help: "help.suggestedTaxonPublication",
            value: null,
            defaultValue: null,
            //    Deactivated as suggested by Silvia Stofer
            // }, {
            //     name: "suggestedTaxonDescription",
            //     type: "string",
            //     title: "help.suggestedTaxonDescriptionTitle",
            //     component: ComponentEnum.StringPicker,
            //     multiple: false,
            //     required: false,
            //     placeholder: 'help.suggestedTaxonDescriptionPlaceholder',
            //     help: "help.suggestedTaxonDescription",
            //     value: null,
            //     defaultValue: null,
        }, {
            name: "suggestedTaxonComment",
            type: "string",
            title: "help.suggestedTaxonCommentTitle",
            component: ComponentEnum.StringPicker,
            multiple: false,
            required: false,
            placeholder: "help.suggestedTaxonCommentPlaceholder",
            help: "help.suggestedTaxonComment",
            value: null,
            defaultValue: null,
        }]
}

export const newTaxon = function () {
    return [
        {
            name: "ifFlorAppReferenceWork",
            type: "hidden",
            title: "help.ifFlorAppReferenceWorkTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "reference",
            required: true,
            multiple: false,
            clearable: true,
            filter: false,
            placeholder: null,
            help: "help.ifFlorAppReferenceWork",
            value: null,
            defaultValue: null,
        }, {
            name: "taxonId",
            type: "number",
            title: "help.taxonIdTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "taxon",
            required: true, // is automatically set to dummy taxon id in backend, if not given and a suggested taxon name is provided
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.taxonId",
            value: null,
            defaultValue: null,
        }]
}


export const newSpecimen = function () {
    return [
        {
            component: ComponentEnum.CategoryPicker,
            name: "specimenType",
            type: "number",
            title: "help.specimenTypeTitle",
            api: lookupURL + "specimen_type",
            multiple: true,
            required: true,
            clearable: false,
            filter: false,
            placeholder: null,
            help: "help.specimenType",
            value: null,
            defaultValue: 2, // herbaria specimen
        },
        {
            component: ComponentEnum.CategoryPicker,
            name: "herbarium",
            type: "number",
            title: "help.herbariumTitle",
            api: lookupURL + "herbarium",
            multiple: false,
            required: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.herbarium",
            value: null,
            defaultValue: 1, // PRIV Herbar
        },
        {
            component: ComponentEnum.StringPicker,
            name: "specimenLabel",
            type: "string",
            title: "help.specimenLabelTitle",
            multiple: false,
            required: false,
            placeholder: "help.specimenLabelPlaceholder",
            help: "help.specimenLabel",
            value: null,
            defaultValue: null,
        }
    ]
}

export const newSite = function () {
    return [
        {
            name: "siteId",
            type: "hidden",
            title: "",
            component: ComponentEnum.NumberPicker,
            api: "",
            required: false,
            multiple: false,
            placeholder: null,
            help: "",
            value: null,
            defaultValue: null,
        },
        {
            name: "coords",
            type: "location",
            title: "help.locationTitle",
            component: ComponentEnum.LocationPicker,
            value: [],
            required: true,
            multiple: false,
            help: "help.location",
            defaultValue: null,
        }, {
            name: "precisionXY",
            type: "number",
            unit: "m",
            title: "help.precisionXYTitle",
            component: ComponentEnum.NumberPicker,
            value: null,
            required: true,
            multiple: false,
            placeholder: 'help.precisionXYPlaceholder',
            min: 0,
            max: 50000,
            help: "help.precisionXY",
            defaultValue: null,
        }, {
            name: "z",
            type: "number",
            unit: "meters",
            title: "help.zTitle",
            component: ComponentEnum.NumberPicker,
            value: null,
            required: false,
            multiple: false,
            placeholder: 'help.zPlaceholder',
            min: 180,
            max: 4700,
            help: "help.z",
            defaultValue: null,
        }, {
            name: "locality",
            type: "string",
            title: "help.localityTitle",
            component: ComponentEnum.StringPicker,
            value: null,
            required: false,
            multiple: false,
            placeholder: "help.localityPlaceholder",
            help: "help.locality",
            defaultValue: null,
        }, {
            name: "delarzeHabitat",
            type: "number",
            title: "help.delarzeHabitatTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "habitat",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.delarzeHabitat",
            value: null,
            defaultValue: null,
        },
        {
            name: "commentSurvey",
            type: "string",
            title: "help.commentSurveyTitle",
            component: ComponentEnum.StringPicker,
            required: false,
            multiple: false,
            placeholder: "help.commentSurveyPlaceholder",
            help: "help.commentSurvey",
            value: null,
            defaultValue: null,
        }, {
            name: "commentSite",
            type: "string",
            title: "help.commentSiteTitle",
            component: ComponentEnum.StringPicker,
            required: false,
            multiple: false,
            placeholder: "help.commentSitePlaceholder",
            help: "help.commentSite",
            value: null,
            defaultValue: null,
        }, {
            name: "florAppVegetationSurvey",
            type: "string",
            title: "help.florAppVegetationSurveyTitle",
            component: ComponentEnum.StringPicker,
            required: false,
            multiple: false,
            placeholder: "help.florAppVegetationSurveyPlaceholder",
            help: "help.florAppVegetationSurvey",
            value: null,
            defaultValue: null,
        }
    ]
}

export const newRecord = function () {
    return [
        {
            name: "precisionDate",
            type: "number",
            title: "help.precisionDateTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "precision_date",
            required: false,
            multiple: false,
            clearable: false,
            filter: false,
            help: "help.precisionDate",
            value: null,
            defaultValue: 1,  // ID = 1 for +-1 day of precision
        },
        {
            name: "recordDate",
            type: "date",
            title: "help.recordDateTitle",
            component: ComponentEnum.DatePicker,
            required: true,
            multiple: false,
            placeholder: null,
            help: "help.recordDate",
            value: null,
            defaultValue: null,
        },
        {
            name: "taxonReferenceSuggested",
            type: "group",
            title: "help.taxon",
            component: ComponentEnum.TaxonPicker,
            api: lookupURL + "reference",
            required: true,
            multiple: false,
            placeholder: null,
            help: "help.taxonId",
            value: [...newTaxon(), ...newSuggestedTaxon()],
            defaultValue: null,
        },
        {
            name: "certainty",
            type: "number",
            title: "help.certaintyTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "certainty",
            required: true,
            multiple: false,
            clearable: false,
            filter: true,
            placeholder: null,
            help: "help.certainty",
            value: null,
            defaultValue: 1, // ID = 1 (certain determination)
        },
        {
            name: "determinationType",
            type: "number",
            title: "help.determinationTypeTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "determinationType",
            required: true,
            multiple: false,
            clearable: false,
            filter: false,
            placeholder: null,
            help: "help.determinationType",
            value: null,
            defaultValue: 1, // ID = 1 (morphological determination)
        },
        {
            name: "project",
            type: "number",
            title: "help.projectTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "project",
            multiple: false,
            clearable: false,
            filter: true,
            required: false,
            placeholder: null,
            help: "help.project",
            value: null,
            defaultValue: 1, // Floristische Beobachtungen (Privat)
        },
        {
            name: "substrateCoarse",
            type: "number",
            title: "help.substrateCoarseTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "substrateCoarse",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.substrateCoarse",
            value: null,
            defaultValue: null,
        },
        {
            name: "substrateFine",
            type: "number",
            title: "help.substrateFineTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "substrateFine",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.substrateFine",
            value: null,
            defaultValue: null,
        },
        {
            name: "woodyPlant",
            type: "number",
            title: "help.woodyPlantTitle",
            component: ComponentEnum.MultiSelectPicker,
            api: lookupURL + "woodyPlant",
            required: false,
            multiple: false,
            placeholder: null,
            help: "help.woodyPlant",
            value: null,
            defaultValue: null,
        },
        {
            name: "fruitbody",
            type: "number",
            title: "help.fruitbodyTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "fruitbody",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.fruitbody",
            value: null,
            defaultValue: null,
        }, {
            name: "woodDegradation",
            type: "number",
            title: "help.woodDegradationTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "woodDegradation",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.woodDegradation",
            value: null,
            defaultValue: null,
        }, {
            name: "woodQuality",
            type: "number",
            title: "help.woodQualityTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "woodQuality",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.woodQuality",
            value: null,
            defaultValue: null,
        }, {
            name: "hostPlant",
            type: "number",
            title: "help.hostPlantTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "hostPlant",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.hostPlant",
            value: null,
            defaultValue: null,
        }, {
            name: "hostFungus",
            type: "number",
            title: "help.hostFungusTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "hostFungus",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.hostFungus",
            value: null,
            defaultValue: null,
        }, {
            name: "hostLichen",
            type: "number",
            title: "help.hostLichenTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "hostLichen",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.hostLichen",
            value: null,
            defaultValue: null,
        }, {
            name: "sexualStage",
            type: "number",
            title: "help.sexualStageTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "sexualStage",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.sexualStage",
            value: null,
            defaultValue: null,
        }, {
            name: "sporeTypeRusts",
            type: "number",
            title: "help.sporeTypeRustsTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "sporeTypeRusts",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.sporeTypeRusts",
            value: null,
            defaultValue: null,
        },
        {
            name: "determinationLiterature",
            type: "number",
            title: "help.determinationLiteratureTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "literature",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.determinationLiterature",
            value: null,
            defaultValue: null,
        }, {
            name: "publication",
            type: "number",
            title: "help.publicationTitle",
            component: ComponentEnum.CategoryPicker,
            api: lookupURL + "publication",
            required: false,
            multiple: false,
            clearable: true,
            filter: true,
            placeholder: null,
            help: "help.publication",
            value: null,
            defaultValue: null,
        }, {
            name: "leg",
            type: "number",
            title: "help.legTitle",
            component: ComponentEnum.PersonPicker,
            value: null,
            api: lookupURL + "personByEmail",
            required: true,
            multiple: true,
            placeholder: null,
            help: "help.leg",
            defaultValue: null,
        }, {
            name: "det",
            type: "number",
            title: "help.detTitle",
            component: ComponentEnum.PersonPicker,
            value: null,
            api: lookupURL + "personByEmail",
            required: false,
            multiple: true,
            placeholder: null,
            help: "help.det",
            defaultValue: null,
        }, {
            name: "vis",
            type: "number",
            title: "help.visTitle",
            component: ComponentEnum.PersonPicker,
            value: null,
            api: lookupURL + "personByEmail",
            required: false,
            multiple: true,
            placeholder: null,
            help: "help.vis",
            defaultValue: null,
        }, {
            name: "commentRecord",
            type: "string",
            title: "help.commentRecordTitle",
            component: ComponentEnum.StringPicker,
            multiple: false,
            required: false,
            placeholder: "help.commentRecordPlaceholder",
            help: "help.commentRecord",
            value: null,
            defaultValue: null,
        }, {
            name: "images",
            type: "image",
            title: "help.imagesTitle",
            component: ComponentEnum.ImagePicker,
            api: "",
            multiple: true,
            required: false,
            placeholder: null,
            help: "help.images",
            value: [],
            defaultValue: null,
        },
        {
            name: "specimens",
            type: "group",
            title: "help.specimensTitle",
            component: ComponentEnum.SpecimenPicker,
            api: "",
            multiple: true,
            required: false,
            placeholder: null,
            help: "help.specimens",
            value: [],
            defaultValue: null,
        },
        {
            name: "recordId",
            type: "hidden",
            title: "",
            component: ComponentEnum.NumberPicker,
            api: "",
            required: false,
            multiple: false,
            placeholder: null,
            help: "",
            value: null,
            defaultValue: null,
        }
    ]
}

export const newImage = function () {
    return [
        {
            name: "imageBlob",
            type: "image",
            title: "help.imagesTitle",
            component: ComponentEnum.StringPicker,
            api: "",
            multiple: true,
            required: false,
            placeholder: null,
            help: "help.images",
            value: null,
            defaultValue: null,
        }, {
            name: "fileName",
            type: "image",
            title: "help.imagesTitle",
            component: ComponentEnum.StringPicker,
            api: "",
            multiple: true,
            required: false,
            placeholder: null,
            help: "help.images",
            value: null,
            defaultValue: null,
        }, {
            name: "fileType",
            type: "image",
            title: "help.imagesTitle",
            component: ComponentEnum.StringPicker,
            api: "",
            multiple: true,
            required: false,
            placeholder: null,
            help: "help.images",
            value: null,
            defaultValue: null,
        },
    ]
}
